// Maps to the Cohort Mapping Table defined here https://nerdwallet.atlassian.net/wiki/spaces/PEDD/pages/2589523997/Registration+Analytics+Cohort+Mapping
const COHORTS = {
  CREDIT_SCORE: 'credit_score',
  LESS_GOOGLING: 'less_googling',
  MONEY_GAME: 'money_game',
  FINANCIAL_CLARITY: 'financial_clarity',
  PONDER_NEXT_MOVE: 'ponder_next_move',
  MONEY_INSIGHTS: 'money_insights',
  COPY_CHANGE: 'copy_change',
  G1T: 'google_one_tap',
  NEW_INSIGHTS: 'new_insights',
  KNOW_YOUR_CASH_FLOW: 'know_your_cash_flow',
  INTRO_TO_HOMEBUYING: 'intro_to_homebuying',
  MAKE_RIGHT_MOVE: 'make_right_move',
  RETIREMENT_PLANNING: 'retirement_planning',
  SMART_HOME_BUYING: 'smart_home_buying',
  PERSONALIZED_INSIGHTS: 'personalized_insights',
  ALL_IN_ONE_PLACE_ACCOUNT: 'all_in_one_place_account',
};

const IGNORABLE_SHARED = {
  v1: 'ignorable_modal_v1',
  v2: 'ignorable_modal_v2',
  v3: 'ignorable_modal_v3',
  v4: 'ignorable_modal_v4',
  entity_names: {
    display: 'ignorable_modal',
    x_button: 'close_button',
    download_now_button: 'download_now_button',
    auth_buttons: 'auth_button',
    success: 'success_modal',
    error: 'error_modal',
    email_signin: 'email_signin',
    email_register: 'email_register',
  },
  additional_attributes: {
    target_flow: 'no_security_question',
    cta_mode: 'modal',
    cta_label: 'continue_with',
    cta_format: 'button',
    cta_format_link: 'link',
    auth_type: 'register',
    element_type: 'modal',
  },
};

export const IGNORABLE_V1 = {
  section_name: IGNORABLE_SHARED.v1,
  cohort: COHORTS.MONEY_GAME,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v1,
    trk_format: COHORTS.MONEY_GAME,
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v1,
    driverSubLocation: COHORTS.MONEY_GAME,
  },
};

export const IGNORABLE_V2_CREDIT_SCORE = {
  section_name: IGNORABLE_SHARED.v2,
  cohort: COHORTS.CREDIT_SCORE,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v2,
    trk_format: COHORTS.CREDIT_SCORE,
    trk_vertical: 'Credit Cards',
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v2,
    driverSubLocation: COHORTS.CREDIT_SCORE,
  },
};

export const IGNORABLE_V2_PLAID_ACTIVATION = {
  section_name: IGNORABLE_SHARED.v2,
  cohort: COHORTS.KNOW_YOUR_CASH_FLOW,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v2,
    trk_format: COHORTS.KNOW_YOUR_CASH_FLOW,
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v2,
    driverSubLocation: COHORTS.KNOW_YOUR_CASH_FLOW,
  },
};

export const IGNORABLE_V3_INVESTING = {
  section_name: IGNORABLE_SHARED.v3,
  cohort: COHORTS.PONDER_NEXT_MOVE,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v3,
    trk_format: COHORTS.PONDER_NEXT_MOVE,
    trk_vertical: 'Investing',
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v3,
    driverSubLocation: COHORTS.PONDER_NEXT_MOVE,
  },
};

export const IGNORABLE_V3_MORTGAGES = {
  section_name: IGNORABLE_SHARED.v3,
  cohort: COHORTS.SMART_HOME_BUYING,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v3,
    trk_format: COHORTS.SMART_HOME_BUYING,
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v3,
    driverSubLocation: COHORTS.SMART_HOME_BUYING,
  },
};

export const IGNORABLE_V3_RETIREMENT = {
  section_name: IGNORABLE_SHARED.v3,
  cohort: COHORTS.RETIREMENT_PLANNING,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v3,
    trk_format: COHORTS.RETIREMENT_PLANNING,
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v3,
    driverSubLocation: COHORTS.RETIREMENT_PLANNING,
  },
};

export const IGNORABLE_V3_RIGHT_MOVE = {
  section_name: IGNORABLE_SHARED.v3,
  cohort: COHORTS.MAKE_RIGHT_MOVE,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v3,
    trk_format: COHORTS.MAKE_RIGHT_MOVE,
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v3,
    driverSubLocation: COHORTS.MAKE_RIGHT_MOVE,
  },
};

export const IGNORABLE_V3_INSIGHTS = {
  section_name: IGNORABLE_SHARED.v3,
  cohort: COHORTS.PERSONALIZED_INSIGHTS,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v3,
    trk_format: COHORTS.PERSONALIZED_INSIGHTS,
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v3,
    driverSubLocation: COHORTS.PERSONALIZED_INSIGHTS,
  },
};

export const IGNORABLE_V3_ACCOUNT = {
  section_name: IGNORABLE_SHARED.v3,
  cohort: COHORTS.ALL_IN_ONE_PLACE_ACCOUNT,
  entity_names: IGNORABLE_SHARED.entity_names,
  trk: {
    trk_location: IGNORABLE_SHARED.v3,
    trk_format: COHORTS.ALL_IN_ONE_PLACE_ACCOUNT,
  },
  additional_attributes: IGNORABLE_SHARED.additional_attributes,
  segmentTrackingAttributes: {
    driverLocation: IGNORABLE_SHARED.v3,
    driverSubLocation: COHORTS.ALL_IN_ONE_PLACE_ACCOUNT,
  },
};

export const G1T = {
  section_name: 'google_one_tap_modal',
  cohort: COHORTS.G1T,
  entity_names: {
    display: 'google_one_tap',
    x_button: 'close_button',
    login: 'login_attempt',
    failed_render: 'failed_render',
    success: 'login_success',
    error: 'login_error',
    eoru_tu_funnel: 'eoru_tu_activation_modal',
  },
  trk: {
    trk_location: 'google_one_tap_modal',
    trk_format: COHORTS.G1T,
  },
  segmentTrackingAttributes: {
    driverLocation: 'google_one_tap_modal',
    driverSubLocation: COHORTS.G1T,
    driverElement: 'button',
  },
  additional_attributes: {
    element_type: 'modal',
  },
};

const GLOBAL_NAV_REG_CTA_SHARED = {
  v1: 'global_nav_reg_cta_v1',
  entity_names: {
    signin: 'signin_button',
    signin_link: 'signin_link',
    register: 'register_button',
    display: 'reg_cta_container',
    indicator: 'notification_indicator',
    mynw_button: 'mynw_button',
    x_button: 'close_button',
    navigate_away: 'navigate_away',
    auth_buttons: 'auth_button',
    success: 'success_modal',
    error: 'error_modal',
  },
  additional_attributes: {
    cta_mode: 'modal',
    cta_format: 'button',
    cta_format_link: 'link',
    auth_type: 'register',
  },
};

// analytics for the Sign in/Sign up buttons in the global nav
export const GLOBAL_NAV_REG_CTA_V1 = {
  section_name: GLOBAL_NAV_REG_CTA_SHARED.v1,
  cohort: COHORTS.NEW_INSIGHTS,
  entity_names: {
    registration_cta: 'lets_do_this_button',
    ...GLOBAL_NAV_REG_CTA_SHARED.entity_names,
  },
  trk: {
    trk_location: GLOBAL_NAV_REG_CTA_SHARED.v1,
    trk_format: COHORTS.NEW_INSIGHTS,
  },
  additional_attributes: {
    target_flow: 'onboarding-generic',
    cta_label: 'lets_do_this',
    ...GLOBAL_NAV_REG_CTA_SHARED.additional_attributes,
  },
  segmentTrackingAttributes: {
    driverLocation: GLOBAL_NAV_REG_CTA_SHARED.v1,
    driverSubLocation: COHORTS.NEW_INSIGHTS,
  },
};
